/**
 * Global constants for VerbO
 */

export const APP_RULES_VERSION = 1;

export const RULES_DESCRIPTION = "Versión inicial: Vocabulario base + Sistema de impugnaciones v1.";
